module.exports = __webpack_public_path__ + "img/yich_logo.c1c67da5.png";